import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserConfigService } from '../user-config/user-config.service';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard {
  constructor(
    private userConfig: UserConfigService,
    private authService: AuthenticationService,
    private router: Router,
    private loggerService: LoggerService,
  ) {}
  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Observable((observer) => {
      if (environment.isLocal) {
        const localAuthToken = localStorage.getItem('auth-token');
        if (localAuthToken) {
          this.authService.setLoggedIn(true);
          observer.next(true);
        }
      } else {
        this.userConfig.getUserInfo().subscribe((userData) => {
          if (userData) {
            observer.next(true); // when getting user data
          } else {
            if (this.router.url != '/logout') {
              //this.authService.loginRedirect();
              this.loggerService.log('Userinfo not found');
            }
          }
        });
      }
    });
  }
}
